export default {
      id: "btn_profile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#btn_profile",
      toString: function () {
        return this.url;
      }
    }